import {lockBodyScroll} from './helpers.js';
import { initReadMoreButtons } from './ui-helpers.js';

(function(){
    function updateTourCollectionModal(src,price,title,additional,url){
        const modalImage = document.querySelector('[data-tour-modal-image]')
        const modalPrice = document.querySelector('[data-tour-modal-price]')
        const modalTitle = document.querySelector('[data-tour-modal-title]')
        const modalAdditionalInfo = document.querySelector('[data-tour-modal-additional_info]')
        const modalUrl = document.querySelector('[data-tour-modal-url]')
        modalImage.src = src;
        modalPrice.textContent = price;
        modalTitle.textContent = title;
        modalAdditionalInfo.innerHTML = additional;
        modalUrl.href = url;
        console.log("inner html content",modalAdditionalInfo.innerHtml)
    }

    function initTourCollectionModal(){
        window.addEventListener('click',function(e){
            // console.log('E.TARGET',e.target);
            if(e.target.hasAttribute('data-tour-additional-info-trigger')){
                const modalValues = e.target.previousElementSibling;
                const src = modalValues.querySelector("[data-tour-img-src]")?.dataset?.tourImgSrc|| ''
                const price = modalValues.querySelector("[data-tour-price]")?.dataset?.tourPrice || ''
                const url = modalValues.querySelector("[data-tour-url]")?.dataset?.tourUrl || ''
                const title = modalValues.querySelector("[data-tour-title]")?.dataset?.tourTitle || ''
                const additional = modalValues.querySelector("[data-tour-additional]")?.dataset?.tourAdditional || ''
                updateTourCollectionModal(src,price,title,additional,url);
            }
            
        })
        window.addEventListener("change",function(e){
            if(e.target.hasAttribute('data-tour-modal-checkbox')){
                console.log("input changed")
                lockBodyScroll(!document.body.classList.contains('overflow-hidden'));
                // document.documentElement.classList.toggle("overflow-hidden", !document.documentElement.classList.contains('overflow-hidden'));
                
            }
        })
        initReadMoreButtons();
    }
    initTourCollectionModal();
    })()